import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, FormArray, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { ContractNumberRequest } from '../../shared/models/contractNumberResponse';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { DcsAccountNumber } from '../../shared/models/dcsAccountNumber';
import { Console } from 'console';
import { VinDetailsResponse } from '../../shared/models/VinDetailsResponse';
import { AccountNumber } from '../../shared/models/accountNumber';
import { VinResponse } from '../../shared/vinResponse';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatButtonModule } from '@angular/material/button';
import { OdomList } from '../../shared/models/OdomList';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-titletransfer',
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatPaginator, MatSort, MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, FormsModule, MatSortModule
    ],
    templateUrl: './titletransfer.component.html',
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class TitleTransferComponent implements OnInit {

  router: Router;
  vinIndex = 0;
  showNxtAssetBtn = false;
  @ViewChildren('myInput') myInput: QueryList<ElementRef>;
  x: any;
  token: string;
  brandId: string;
  noOfRepetetions = new Array(1);
  // selectAll = false;
  showAccounts = true;
  showVinDetails = false;
  showVinForm = false;
  showOdometer = false;
  selectedVinAccounts = "";
  selected: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  emailAddress = '';
  phoneNumber = '';
  name = '';
  fax = '';
  nameOfDMV = '';
  DMVAddress = '';
  DMVPhone = '';
  DMVStateCityZip = '';
  state = '';
  index: 0;
  // odometer = 1;
  usUrl: string;
  caUrl: string;
  azURL: string;
  statementPeriod: string;
  displayValue: string;

  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  error = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  language = '';
  ciamId = sessionStorage.getItem('loginID');
  myForm: FormGroup;
  hideArray: Array<string> = [];
  accountDetailsRes: AccoutDetailsResponse[];
  odoms: OdomList[];
  vinDetailsRes: VinDetailsResponse[];
  selectedAccountList: AccountNumber[];
  selectedAccount: AccountNumber;
  contractSelected = false;
  disabledFlag = false;
  odomListPrefill: string[] = [];
  vinsObjList: any[] = [];
  selectedContractNum: string;
  vinNumber = '';
  dataLoaded = true;
  tableLoaded = true;
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option6;
  value = '';
  filterActive = false;
  filter = false;
  rowCount = 0;
  dropDownList: Array<any> = [];
  selectedVinNumber: string[] = [];
  selectedAccounts: string[] = [];
  vinReadOnly = 'N';
  qtd: any[] = [];
  // @ViewChildren
  // vins
  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'contractNum',
      display: 'Account',
      displayFR: 'Compte',
      dispFormat: 'contract'
    },
    {
      name: 'lastPayRcvd',
      display: 'Last Payment',
      displayFR: 'Dernier paiement reçu',
      dispFormat: 'currency'
    },
    {
      name: 'contractType',
      display: 'Account Type',
      displayFR: 'Type de compte',
      dispFormat: ''
    },
    {
      name: 'termDate',
      display: 'Maturity Date',
      displayFR: 'Date de maturité',
      dispFormat: 'date'
    },
    {
      name: 'totalDue',
      display: 'Current Due',
      displayFR: 'Solde actuel',
      dispFormat: 'currency'
    },
    {
      name: 'currentDt',
      display: 'Due Date',
      displayFR: 'Date d\'échéance',
      dispFormat: 'date'
    },
    {
      name: 'status',
      display: 'Status',
      displayFR: 'Statu',
      dispFormat: ''
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  //vin table columns
  vininitColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'vinNum',
      display: 'VIN',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'account',
      display: 'Account',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'year',
      display: 'Year',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'model',
      display: 'Model',
      displayFR: '',
      dispFormat: ''
    }
  ];
  vindisplayedColumns: any[] = this.vininitColumns.map(col => col.name);

  dataSource: MatTableDataSource<AccoutDetailsResponse>;
  vinDataSource: MatTableDataSource<VinDetailsResponse>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<AccoutDetailsResponse>(true, []);
  vinselection = new SelectionModel<VinDetailsResponse>(true, []);

  stateLabelValues = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Guam', value: 'GU' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
  ];


  //constructor
  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog
  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.accountDetailsRes = [];
    this.dataSource = new MatTableDataSource(this.accountDetailsRes);
    this.vinDetailsRes = [];
    this.vinDataSource = new MatTableDataSource(this.vinDetailsRes);
  }

  ngOnInit() {
    this.emailAddress = sessionStorage.getItem('emailAddress');
    this.myForm = this.fb.group({
      DMVAddress: [''],
      DMVStateCityZip: [''],
      state: [''],
      fax: [''],
      vinNumber: [[]],
      DMVPhone: [''],
      odometer: this.fb.array([]),
      nameOfDMV: ['']
    });
    const language = (window as any).mbfs.language;
    this.language = language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.getDashBoardDetails(dashBoardRequest);
    this.getAccountDetailsListByUserId();
   // this.getAlerts();
    // this.selectAll=false;
  }

  ngAfterViewInit() {
  }

  // Get User details & address
  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
      this.name = res.name;
      this.DMVAddress = res.address1;
      this.DMVStateCityZip = res.city + " " + res.state + " " + res.zip;

    });
  }

  //Get acciunt details by user id
  getAccountDetailsListByUserId() {
    const accountDetailsRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
      res.accountdetailsList.filter(i => i.status == 'LIVE').map(m => this.accountDetailsRes.push(m))
      this.dataSource = new MatTableDataSource(this.accountDetailsRes);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function (data, filter: string): boolean {
        return data.contractNum.toLowerCase().includes(filter) || data.status.toLowerCase().includes(filter) || data.contractType.toLowerCase().includes(filter);
      };
      setTimeout(() => {
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.dataSource.filteredData.length;
      });
    });
  }
  // get alert details
  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }



  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  //form validations
  formValidationClasses = {
    'mbfs-error': true,
  };

  //account table filter
  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  // submit account 
  submitForm(event: Event) {
    this.checkToggleSelected();
    if (this.contractSelected) {
      this.showVinDetails = true;
      this.myForm.reset();
      this.showVinForm = false;
      this.showAccounts = false;
      this.getVinDetails();
    } else {
      this.disabledFlag = false;
    }
  }

  checkToggleSelected() {
    this.selectedAccountList = [];
    const numSelected = this.selection.selected.length;
    if (numSelected < 1) {
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.SelectOneAccount').subscribe((data: any) => {
        this.error = data;
      });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
    }
    else {
      this.contractSelected = true;
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
      this.selectedAccount = new AccountNumber();
      this.selectedAccount.contractNumber = this.selection.selected[i].contractNum.slice(0, -3);
      this.selectedAccount.contractType = this.selection.selected[i].contractType;
      this.selectedAccount.scheduleNumber = "1";
      this.selectedAccountList.push(this.selectedAccount);
      this.selectedContractNum = this.selection.selected.map(x => x.contractNum).join(", ");
    }
  }

  //  get vin table details from db 
  getVinDetails() {
    this.tableLoaded = false;

    const request = { "accountList": this.selectedAccountList };
    this.auth.getVinDetails(request).subscribe(res => {
      window.scrollTo(0, 0);
      if (res) {
        this.vinDetailsRes = [];
        res.forEach(element => {
          this.vinDetailsRes.push(element);
        });
        this.vinDataSource = new MatTableDataSource(this.vinDetailsRes);
        this.vinDataSource.paginator = this.paginator;
        this.vinDataSource.sort = this.sort;
        this.tableLoaded = true;
        this.vinDataSource.filterPredicate = function (data, filter: string): boolean {
          return data.vinNum.toLowerCase().includes(filter);
        };
        setTimeout(() => {
          this.dbLoaded = true;
          this.filter = true;
          this.rowCount = this.dataSource.filteredData.length;
        });
      }
    });
  }

  //vin table filter
  applyVinFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.vinDataSource.filter = filterValue.trim().toLowerCase();
    if (this.vinDataSource.paginator) {
      this.vinDataSource.paginator.firstPage();
    }
    this.rowCount = this.vinDataSource.filteredData.length;
  }
  // 
  continue(e: Event) {
    const numSelected = this.vinselection.selected.length;

    if (numSelected < 1) {
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.SelectOneVin').subscribe((data: any) => {
        this.error = data;
      });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
      return;
    }
    this.vinReadOnly = 'N';
    this.vinIndex = 0;
    this.vinsObjList = [];
    this.dropDownList = [];
    this.vinselection.selected.map(x => { this.dropDownList.push({ selection: x.vinNum, id: x.vinNum }); })
    this.showVinForm = true;
    this.showAccounts = false;
    this.showVinDetails = false;
    this.showNxtAssetBtn = true;
  }

  onSelectionChange(event?: Event) {
    this.selectedVinNumber = [];
    this.selectedVinNumber = event["value"];

    this.showNxtAssetBtn = true;
    if (this.selectedVinNumber.length === this.dropDownList.length) {
      this.showNxtAssetBtn = false;
    }
  }
  nextAsset() {

    this.x = this.myInput.map(alertInstance => alertInstance.nativeElement.value).join(" ");
    if (this.myForm.controls['DMVPhone'].valid &&
      this.myForm.controls['DMVAddress'].valid &&
      this.myForm.controls['DMVStateCityZip'].valid &&
      this.myForm.controls['nameOfDMV'].valid &&
      this.myForm.controls['state'].valid &&
      this.myForm.controls['vinNumber'].valid && this.x
    ) {
      this.vinReadOnly = "N";
      this.updateData();
      this.vinIndex = this.vinIndex + 1;
      var vinObj = this.vinsObjList[this.vinIndex];
      if (undefined !== vinObj) {
        this.vinReadOnly = "Y";
        this.vinNumber = vinObj.vinNum;
        this.myForm.get('fax').setValue(vinObj.fax);
        this.myForm.get('DMVPhone').setValue(vinObj.dmvphone),
          this.myForm.get('DMVAddress').setValue(vinObj.dmvPhysicalStreetAddress),
          this.myForm.get('DMVStateCityZip').setValue(vinObj.dmvCityStateZip),
          this.myForm.get('state').setValue(vinObj.state),
          this.myForm.get('nameOfDMV').setValue(vinObj.nameOfDMV);
        //odomodometer
        const odometer = this.myForm.get('odometer') as FormArray;
        while (odometer.length !== 0) {
          odometer.removeAt(0)
        }
        var a = vinObj.odometer;
        var b = a.split(',').map(function (item) {
          return parseInt(item);
        });

        const numbers = b;

        numbers.forEach(number => {
          odometer.push(this.fb.group({ odometer: [number, Validators.required] }));
        })
        this.selectedVinNumber = vinObj.vinNum.split(',');
      }
    }
  }

  submitVinForm() {
    if (this.vinReadOnly == "N") {
      window.scrollTo(100, 100);
      var r = this.selectedVinNumber;
      this.dropDownList = this.dropDownList.filter(function (item) {
        return !r.includes(item.id);
      })
      var accList = []
      var list = []
      this.vinselection.selected.filter(x => { if (this.selectedVinNumber.includes(x.vinNum)) { list.push(x) } });

      list.forEach(element => {
        accList.push(element.account);
      });

      accList = accList.filter((item, index) => accList.indexOf(item) === index);

      if (this.dropDownList.length == 0) {
        //fill request
        const docRequestFormRequest = {
          ciamId: this.ciamId,
          ciamAZCode: this.token,
          emailAddress: this.emailAddress,
          firstName: this.name,
          myDoc: "title state transfer",
          fax: this.fax,
          primaryCustomerAgreementNumber: accList.join(', '),
          dmvPhysicalStreetAddress: this.DMVAddress,
          dmvCityStateZip: this.DMVStateCityZip,
          nameOfDMV: this.nameOfDMV,
          state: this.state,
          odometer: this.myInput.map(alertInstance => alertInstance.nativeElement.value).join(", "),
          title: this.nameOfDMV,
          phone: this.DMVPhone,
          country: this.currentCountry,
          language: this.language,
          vinNum: this.selectedVinNumber.join(",")
        };


        this.vinsObjList.push(docRequestFormRequest);
        // localStorage.setItem(this.selectedVinNumber.join(","), JSON.stringify(docRequestFormRequest));
        // localStorage.setItem(this.vinIndex - 1 + '', JSON.stringify(docRequestFormRequest));
        this.vinsObjList.forEach(e => {
          this.sendMail(e);
        });
        // this.sendMail(docRequestFormRequest);
        this.openDialog(2);
      }
      else {
        const docRequestFormRequest = {
          ciamId: this.ciamId,
          ciamAZCode: this.token,
          emailAddress: this.emailAddress,
          firstName: this.name,
          phone: this.DMVPhone,
          myDoc: "title state transfer",
          primaryCustomerAgreementNumber: accList.join(', '),
          fax: this.fax,
          dmvPhysicalStreetAddress: this.DMVAddress,
          dmvCityStateZip: this.DMVStateCityZip,
          nameOfDMV: this.nameOfDMV,
          state: this.state,
          odometer: this.myInput.map(alertInstance => alertInstance.nativeElement.value).join(", "),
          title: this.nameOfDMV,
          dmvphone: this.DMVPhone,
          country: this.currentCountry,
          language: this.language,
          vinNum: this.selectedVinNumber.join(",")
        };
        let indexToUpdate = this.vinsObjList.findIndex(item => item.vinNum === this.selectedVinNumber.join(","));
        if (indexToUpdate == -1) {
          this.vinsObjList.push(docRequestFormRequest);
        } else {
          this.vinsObjList[indexToUpdate] = docRequestFormRequest;
        }

        // localStorage.setItem(this.vinIndex - 1 + '', JSON.stringify(docRequestFormRequest));
        this.selectedVinNumber = [];
        this.myForm.reset();
        this.vinNumber = '';
      }
    }
  }
  //back from last to vin page
  backstep2Vin() {
    this.selectedVinNumber = [];
    this.vinNumber = '';
    this.myForm.reset();
    this.vinIndex = this.vinIndex - 1;
    if (this.vinIndex >= 0) {

      var element = this.vinsObjList[this.vinIndex];

      this.vinReadOnly = "Y";
      this.vinNumber = element.vinNum;
      this.selectedVinNumber = element.vinNum.split(',');
      this.myForm.get('vinNumber').setErrors(null);
      // this.myForm.get('vinNumber').setValue("-");
      this.myForm.get('fax').setValue(element.fax);
      this.myForm.get('DMVPhone').setValue(element.dmvphone),
        this.myForm.get('DMVAddress').setValue(element.dmvPhysicalStreetAddress),
        this.myForm.get('DMVStateCityZip').setValue(element.dmvCityStateZip),
        this.myForm.get('state').setValue(element.state),
        this.myForm.get('nameOfDMV').setValue(element.nameOfDMV);

      const odometer = this.myForm.get('odometer') as FormArray;


      while (odometer.length !== 0) {
        odometer.removeAt(0)
      }

      var a = element.odometer;
      var b = a.split(',').map(function (item) {
        return parseInt(item, 10);
      });
      var numbers = b;
      numbers.forEach(number => {
        odometer.push(this.fb.group({ odometer: [number] }));
      })
      this.showVinForm = true;
      this.showAccounts = false;
      this.showVinDetails = false;
      this.showNxtAssetBtn = true;

    } else {
      this.selectedVinNumber = [];
      this.myForm.reset();
      this.vinNumber = '';

      this.showAccounts = false;
      this.showVinDetails = true;
      this.showVinForm = false;
      this.myForm.reset();
      setTimeout(() => {
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.dataSource.filteredData.length;
        this.vinDataSource.paginator = this.paginator;
      });
    }

  }
  updateData() {
    var accList = []
      var list = []
      this.vinselection.selected.filter(x => { if (this.selectedVinNumber.includes(x.vinNum)) { list.push(x) } });

      list.forEach(element => {
        accList.push(element.account);
      });

      accList = accList.filter((item, index) => accList.indexOf(item) === index);
    const docRequestFormRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      emailAddress: this.emailAddress,
      firstName: this.name,
      phone: this.DMVPhone,
      myDoc: "title state transfer",
      primaryCustomerAgreementNumber: accList.join(', '),
      fax: this.fax,
      dmvPhysicalStreetAddress: this.DMVAddress,
      dmvCityStateZip: this.DMVStateCityZip,
      nameOfDMV: this.nameOfDMV,
      state: this.state,
      odometer: this.myInput.map(alertInstance => alertInstance.nativeElement.value).join(", "),
      title: this.nameOfDMV,
      dmvphone: this.DMVPhone,
      country: this.currentCountry,
      language: this.language,
      vinNum: this.selectedVinNumber.join(",")
    };
    let indexToUpdate = this.vinsObjList.findIndex(item => item.vinNum === this.selectedVinNumber.join(","));
    if (indexToUpdate == -1) {
      this.vinsObjList.push(docRequestFormRequest);
    } else {
      this.vinsObjList[indexToUpdate] = docRequestFormRequest;
    }
  }
  
  sendMail(docRequestFormRequest: any) {
    this.auth.contractAndtitleStateTransfer(docRequestFormRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
      }
      else {
        sessionStorage.setItem('addressdialog', 'error');
        this.translate.get('Errors.ErrorHasOccurred').subscribe((data: any) => {
          this.error = data;
        });
        this.auth.SetErrorMessage(this.error);
        this.openDialog(5);
        // If checks to load BE error messages based on language
        if (this.language === 'en-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_EN;
        } else if (this.language === 'fr-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_FR;
        } else {
          this.serviceErrorDesc = res.status.message.shortMessage;
        }
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 7000);  //2s
        this.disabledFlag = false;
      }
      this.dataLoaded = true;
    });
  }

  ////validation

  openDialog(num: any): void {
    if (num === 1) {
      sessionStorage.setItem('addressdialog', 'one');
    }
    if (num === 2) {
      sessionStorage.setItem('addressdialog', 'two');
    }
    if (num === 5) {
      sessionStorage.setItem('addressdialog', 'error');
    }
    let dialogRef = this.dialog.open(TitleTransferDialogComponent, {
      maxWidth: '200vw',
      width: '500px',
    });
  }

  trackByIndex(index: number, item: any) { return index; }

  cancel(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data: any) => {
      redirect = this.usUrl + data;
    });
    window.location.href = redirect;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  // back button code

  //back from account to titletransafer page
  backstep1() {

    this.azURL = this.usUrl + '/home/documentcenter';
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
    }, 1000);

  }

  //back from vin to accounts page
  backstep2Accounts() {
    this.showAccounts = true;
    this.showVinDetails = false;
    this.showVinForm = false;
    this.selectedVinNumber = [];
    this.myForm.reset();

    let arr = this.myInput.toArray()
    arr.forEach(element => {
      element.nativeElement.value = ""
    });

    this.vinNumber = '';
    setTimeout(() => {
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.dataSource.filteredData.length;
      this.dataSource.paginator = this.paginator;
    });


  }

  backstep2Vinold() {
    this.showAccounts = false;
    this.showVinDetails = true;
    this.showVinForm = false;

    this.myForm.reset();
    this.selectedVinNumber = [];
    setTimeout(() => {
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.dataSource.filteredData.length;
      this.vinDataSource.paginator = this.paginator;
    });
  }
}
//----------------------------------------------titleTransferDialogPopup component ------------------------------------------------ 
@Component({
    selector: 'dialog-titleTransferDialogPopup',
    imports: [SharedTranslateModule, MatButtonModule,
        MatDialogContent, MatDialogActions,
        MatDialogClose],
    templateUrl: 'titleTransferDialog.component.html'
})
export class TitleTransferDialogComponent {
  caUrl: string;
  usUrl: string;
  addressdialog: string;
  language: string;
  errorMessage: string;
  contractNumberList: ContractNumberRequest[];

  constructor(router: Router, public auth: AuthorizationService, private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog

  ) {
    this.contractNumberList = [];
    this.addressdialog = sessionStorage.getItem('addressdialog');
    this.language = 'en-US';
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // this.auth.cast2.subscribe((results:any)=> {
    //   this.contractNumberList = results;
    //  });
    this.auth.cast3.subscribe((errorMessage: any) => {
      this.errorMessage = errorMessage;
    });
  }

  dashboardRedirect(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data: any) => {
      redirect = this.usUrl + data;
    });
    window.location.href = redirect;
  }

}



